export default "__VITE_ASSET__DLi3l3YO__"